import Cookies from "js-cookie";

const state = {
  userInfo: {
    type: "",
    country: "",
    email: "",
    mobileNo: "",
    avatar: "",
    username: "",
    point: 0,
    serviceCode: "",
    id: null,
  },
  navbarState: 1,
  isLogin: false,
  isAdmin: false,
  currentLang: Cookies.get("language") || "en",
};

export default state;
